import { styled } from '@mui/material';
import { Link } from 'react-router-dom';
export const ButtonLogin = styled(Link)({
  textDecoration: 'none',
  color: '#fff',
});
